import React, { useState } from 'react';
import AuthUser from '../../../../components/AuthUser';
import { PedidoPDF } from '../../../PDF/PedidoPDF';
import { ProductosPedido } from './ProductosPedido';
import { ProductosPedidoMobile } from './ProductosPedidoMobile';
import { getProductos, getMontoProductosPedido } from '../../../../api/requestPedidos';
import { RequestPage, getVendedor } from '../../../../api/request';
import Pagination from 'react-responsive-pagination';
import { Dropdown, ButtonToolbar } from 'rsuite';
import { Modal } from 'react-bootstrap';
import { RiCloseCircleFill } from "react-icons/ri";
import { SlOptionsVertical } from "react-icons/sl";
import { AiFillEye } from "react-icons/ai";

export const DetallePedido2 = ({ item: Pedidos, vendedor: vendedorProp }) => {
  const { user } = AuthUser();
  const ZonasVenta = user.ZonasVenta;

  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);

  const [vendedor, setVendedor] = useState(vendedorProp || '');
  const [codigoVendedor, setCodigoVendedor] = useState('');
  const [productos, setProductos] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [cantProds, setCantProds] = useState(0);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [urlPage, setUrlPage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const safeNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const formatDate = (d) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('es-MX'); } catch { return '—'; }
  };

  const handleShow = () => {
    setFullscreen(true);
    setShow(true);
    loadProductos();
  };

  const loadProductos = async () => {
    setLoading(true);
    try {
      const [vendResp, prodResp, subtotalResp] = await Promise.all([
        getVendedor(Pedidos.Vendedor),
        getProductos(Pedidos.Documento),
        getMontoProductosPedido(Pedidos.Documento)
      ]);

      const vend = vendResp && Array.isArray(vendResp) && vendResp[0] ? vendResp[0] : null;
      if (vend && vend.CodVendedor === 'V1') setVendedor('OFICINA');
      else setVendedor(vend ? vend.Nombre : (vendedorProp || ''));

      setCodigoVendedor(vend ? vend.CodVendedor : (Pedidos.Vendedor || ''));

      const prod = prodResp && prodResp.data ? prodResp : { data: [], meta: { current_page: 1, last_page: 1 }, links: { first: '' } };
      const monto = Array.isArray(subtotalResp) && subtotalResp[0] ? subtotalResp[0] : { Subtotal: 0, CantProductos: 0 };

      setSubTotal(Number(monto.Subtotal || 0));
      setCantProds(Number(monto.CantProductos || 0));

      setPage(prod.meta?.current_page ?? 1);
      setTotalPages(prod.meta?.last_page ?? 1);
      setUrlPage(prod.links?.first ?? '');

      setProductos(prod.data ?? []);
    } catch (err) {
      console.error('loadProductos error', err);
      setProductos([]);
      setSubTotal(0);
      setCantProds(0);
    } finally {
      setLoading(false);
    }
  };

  const loadPage = async (pageUrl) => {
    if (!pageUrl) return;
    setLoading(true);
    try {
      const resp = await RequestPage(pageUrl);
      setPage(resp.meta?.current_page ?? 1);
      setTotalPages(resp.meta?.last_page ?? 1);
      setUrlPage(resp.links?.first ?? '');
      setProductos(resp.data ?? []);
    } catch (err) {
      console.error('loadPage', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (p) => {
    setCurrentPage(p);
    if (urlPage) {
      const newUrl = urlPage.replace(/.$/, p);
      loadPage(newUrl);
    }
  };

  return (
    <>
      <tr className='d-none-table'>
        <td className='text-danger fw-bold text-center'>{Pedidos.Documento}</td>
        <td>{Pedidos.NombreCliente}</td>
        {(user.CodGerente !== null) ? <td className='d-md-block-table d-none-table fw-bold text-belmeny text-center'>{vendedor}</td> : null}
        <td className='d-md-block-table d-none-table fw-bold text-success text-center'>${safeNumber(Pedidos.Monto).toFixed(2)}</td>
        <td className='text-center'>{formatDate(Pedidos.fechayhora)}</td>
        <td>
          <p className="btn btn-success btn-sm mt-2 mb-2 w-100" onClick={handleShow}>Ver detalles</p>
         {/* <PedidoPDF user={user} Pedido={Pedidos} />*/}
        </td>
      </tr>

      {/* Mobile card */}
      <div className="container-fluid d-block d-sm-block d-md-none">
        <div className="card my-3 drop-shadow border-belmeny">
          <div className="card-body">
            <div className="row">
              <div className="col-9">
                <h5 className="card-title text-belmeny">{(Pedidos.NombreCliente || '').toUpperCase()}</h5>
              </div>
              <div className="col-3">
                <ButtonToolbar>
                  <Dropdown title={<SlOptionsVertical />} activeKey="e-2" className="border-belmeny">
                    <Dropdown.Item eventKey="details"><AiFillEye className='text-belmeny fs-2' onClick={handleShow} /></Dropdown.Item>
                  {/*  <Dropdown.Item eventKey="report"><PedidoPDF user={user} Pedido={Pedidos} /></Dropdown.Item>*/}
                  </Dropdown>
                </ButtonToolbar>
              </div>
            </div>

            <h6 className="card-subtitle mb-2 text-muted fst-italic">{Pedidos.Documento}</h6>
            {(user.CodGerente !== null) ? <h6 className="card-subtitle mb-2 text-belmeny fst-italic">{vendedor}</h6> : null}
            <h6>Monto: <span className="text-success fw-bold">${safeNumber(Pedidos.Monto).toFixed(2)}</span></h6>
            <h6 className='my-1'>Fecha: {formatDate(Pedidos.fechayhora)}</h6>
          </div>
        </div>
      </div>

      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header className='bg-belmeny text-light'>
          <Modal.Title className='fst-italic'>Información del pedido: {Pedidos.Documento}</Modal.Title>
          <Modal.Title><RiCloseCircleFill className='text-danger fs-1 modal-close bg-light rounded-circle' onClick={() => setShow(false)} /></Modal.Title>
        </Modal.Header>

        <div className="division w-100 my-4"></div>
        <Modal.Body>
          <div className="container-fluid">
            <div className='d-none d-md-block'>
              <h3 className="bg-belmeny text-light rounded-pill text-center w-50 m-auto py-1 mb-3">Vendedor Encargado: {vendedor}</h3>

              <div className="row badge-vendedor rounded-pill">
                <div className="col"><h3 className='text-start ms-3'>RIF: {Pedidos.Codcliente}</h3></div>
                <div className="col"><h4 className='text-end me-4'>{Pedidos.NombreCliente}</h4></div>
              </div>

              <div className="container mt-3">
                <div className="row text-center">
                  <div className="col">
                    <h4><b>Fecha del pedido:</b> {formatDate(Pedidos.fechayhora)}</h4>
                    <h4><b>Tipo de pedido:</b> {Pedidos.TipoPedido}</h4>
                    <h4><b>Forma de pago:</b> {Pedidos.FormaPago}</h4>
                  </div>
                  <div className="col">
                    <h4><b>Responsable:</b> {Pedidos.Responsable}</h4>
                    <h4><b>Sincronizado:</b> {(Pedidos.Descargado === 1) ? 'Si' : 'En proceso'}</h4>
                  </div>
                </div>

                <div className="row">
                  <div className="col text-center"><h4><b>Total de productos:</b> {cantProds}</h4></div>
                </div>
              </div>

              <h3 className='bg-belmeny m-auto w-50 rounded-pill py-2 text-center text-light mt-3'>Lista de productos</h3>

              {loading ? <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}><span className="loader-documentos"></span></div> : <>
                <div className="my-3">
                  <table className='table table-responsive table-bordered table-hover border-belmeny'>
                    <thead className='bg-belmeny text-light text-center'>
                      <tr>
                        <th style={{ width: '10%' }}>Imagén</th>
                        <th>Código</th>
                        <th>Producto</th>
                        <th>Precio Unitario</th>
                        <th>Cantidad</th>
                        <th>Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productos.map(p => <ProductosPedido item={p} codVendedor={codigoVendedor} key={p.Codigo} ZonasVenta={ZonasVenta} />)}
                    </tbody>
                  </table>
                </div>

                <Pagination total={totalPages} current={currentPage} onPageChange={p => handlePageChange(p)} />

                <div className="row mt-3">
                  <div className="col">
                    <h4>Comentarios: </h4>
                    <h4 className="border-belmeny p-3 w-75">{Pedidos.Comentarios ? <span>{Pedidos.Comentarios}</span> : <span className='fs-6'>No se agregaron comentarios...</span>}</h4>
                  </div>
                  <div className="col">
                    <h4>Subtotal: </h4>
                    <h2 className='text-end pe-5 fs-1 text-success'>${subTotal.toFixed(2)}</h2>
                  </div>
                  <div className="col">
                    <h4>Total Final: </h4>
                    <h2 className='text-end pe-5 fs-1 text-success'>${safeNumber(Pedidos.Monto).toFixed(2)}</h2>
                  </div>
                </div>
              </>}
            </div>

            {/* MOBILE */}
            <div className='d-block d-sm-none'>
              <h5 className="bg-belmeny text-light rounded-pill text-center m-auto py-1 mb-3">Vendedor Encargado: {vendedor}</h5>
              <div className="badge-vendedor rounded-pill py-2">
                <div className="row"><h5 className='text-center ms-3'>RIF: {Pedidos.Codcliente}</h5></div>
                <div className="row"><h5 className='text-center me-4'>{Pedidos.NombreCliente}</h5></div>
              </div>

              <div className="row mt-3">
                <div className="col text-center">
                  <h6><b>Fecha del pedido:</b> {formatDate(Pedidos.fechayhora)}</h6>
                  <h6><b>Tipo de pedido:</b> {Pedidos.TipoPedido}</h6>
                  <h6><b>Forma de pago:</b> {Pedidos.FormaPago}</h6>
                  <h6><b>Responsable:</b> {Pedidos.Responsable}</h6>
                </div>
              </div>

              {loading ? <div className="text-center mx-auto position-loader-consultas-mobile w-75"><span className="loader-documentos"></span></div> : <>
                <div className="my-3">{productos.map(p => <ProductosPedidoMobile item={p} key={p.Codigo} ZonasVenta={ZonasVenta} />)}</div>
                <Pagination total={totalPages} current={currentPage} onPageChange={p => handlePageChange(p)} />

                <div className="row mt-3">
                  <div className="col"><h4>Comentarios: </h4><h4 className="border-belmeny p-3 w-100">{Pedidos.Comentarios ? <span>{Pedidos.Comentarios}</span> : <span className='fs-6'>No se agregaron comentarios...</span>}</h4></div>
                </div>

                <div className="row mt-4">
                  <div className="col"><h4>Subtotal: <span className="text-success">${subTotal.toFixed(2)}</span></h4></div>
                  <div className="col"><h4>Total Final: <span className="text-success">${safeNumber(Pedidos.Monto).toFixed(2)}</span></h4></div>
                </div>
              </>}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
